import React from 'react'

const Oferta = () => {
  return (
    <div className="flex flex-col h-[calc(100vh-58px)] lg:h-[calc(100vh-85px)] min-h-0">
      <iframe
        className="doc w-full grow min-h-0 pt-10"
        src="./oferta-price-ninja-2026.pdf"
        title="Oferta Price Ninja"
      ></iframe>
    </div>
  )
}
export { Oferta }
